export default __webpack_public_path__ + "static/media/muse.94811323.jpeg";